import React from 'react'
import './index.css'
import Flex from 'components/Flex'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import Button from 'components/Button'
import useSelector from 'hooks/use-selector'
import getAmountGiftSelect from 'modules/gift/redux/selectors/get-amount'
import Span from 'components/Span'
import useDispatch from 'hooks/use-dispatch'
import updateAmountGiftAction from 'modules/gift/redux/actions/update-amount'
import { GIFT_CARD_AMOUNTS } from 'modules/gift/constants'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const ANALYTICS_EVENT = {
  INCREASE_GIFT_CARD_AMOUNT: 'INCREASE_GIFT_CARD_AMOUNT',
  DECREASE_GIFT_CARD_AMOUNT: 'DECREASE_GIFT_CARD_AMOUNT'
}

export default function GiftPageAddAGiftAmountPicker () {
  const isMediumScreen = useIsMediumScreen()
  const amount = useSelector(getAmountGiftSelect)
  const dispatch = useDispatch()
  const amountIndex = GIFT_CARD_AMOUNTS.indexOf(amount)
  const isSelfGifting = isSelfGiftingUrlLocationUtil()
  const previousAmount = isSelfGifting && !amountIndex ? 0 : GIFT_CARD_AMOUNTS[amountIndex - 1]
  const nextAmount = GIFT_CARD_AMOUNTS[amountIndex + 1]
  const debugProps = {
    isMediumScreen,
    amount,
    previousAmount,
    nextAmount,
    isSelfGifting
  }
  logUtil('GiftPageAddAGiftAmountPicker').debug('[start] debugProps=', debugProps)

  const handleClickDecrease = () => {
    logUtil('GiftPageAddAGiftAmountPicker#handleClickDecrease').debug('[start]')
    dispatch(updateAmountGiftAction(previousAmount))
    logEventAnalyticsUtil(ANALYTICS_EVENT.DECREASE_GIFT_CARD_AMOUNT)
  }

  const handleClickIncrease = () => {
    logUtil('GiftPageAddAGiftAmountPicker#handleClickIncrease').debug('[start]')
    dispatch(updateAmountGiftAction(nextAmount))
    logEventAnalyticsUtil(ANALYTICS_EVENT.INCREASE_GIFT_CARD_AMOUNT)
  }

  return (
    <Flex className='gift-add-a-gift-amount-picker'>
      <Button
        onClick={handleClickDecrease}
        disabled={previousAmount == null}
        className='gift-add-a-gift-amount-picker-decrease'
      >
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M19 12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H19C19.414 11.25 19.75 11.586 19.75 12C19.75 12.414 19.414 12.75 19 12.75Z' fill='#838092' />
        </svg>
      </Button>
      <Span className='gift-add-a-gift-amount-picker-amount'>
        ${amount}
      </Span>
      <Button
        onClick={handleClickIncrease}
        disabled={!nextAmount}
        className='gift-add-a-gift-amount-picker-increase'
      >
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M19.75 12C19.75 12.414 19.414 12.75 19 12.75H12.75V19C12.75 19.414 12.414 19.75 12 19.75C11.586 19.75 11.25 19.414 11.25 19V12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H11.25V5C11.25 4.586 11.586 4.25 12 4.25C12.414 4.25 12.75 4.586 12.75 5V11.25H19C19.414 11.25 19.75 11.586 19.75 12Z'
            fill='#191531'
          />
        </svg>
      </Button>
    </Flex>
  )
}
